import React, { Component } from "react";
import AnalyticsDispatcher from "dispatchers/analytics-dispatcher";
import _ from "lodash";
import { connect } from "react-redux";
import SocialDistributionCard from "visual-components/analytics/campaign/social-distribution-card";

class SocialGrowth extends Component {
  state = {
    hideMap: {},
  };

  updateBrand = (brandId) => {
    const data = {
      metric: "campaignSocialActionsByType",
      campaignId: this.props.campaignId,
      specificBrandId: brandId,
    };

    AnalyticsDispatcher.fetchReport(data, "analyticsCampaign");
  };

  toggleItem = (item) => {
    const hideMap = this.state.hideMap;
    hideMap[item] = !hideMap[item];

    this.setState({
      hideMap: hideMap,
    });
  };

  render() {
    const { socialItems, isSolo } = this.props;

    return (
      <SocialDistributionCard
        {...this.props.data}
        hideMap={this.state.hideMap}
        toggleItem={this.toggleItem}
        onChange={this.updateBrand}
        isSolo={isSolo}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.analyticsCampaign.campaignSocialActionsByType,
    campaignId: state.analyticsCampaign.campaign.id,
    isSolo: state.analyticsCampaign.campaign.isSolo,
  };
};

export default connect(mapStateToProps)(SocialGrowth);
